/**
 * /dashboard/timesheet/inbox — Timesheet → Manager / HR approvals
 * (SOP §1.2; Phase 3b — 2026-06-01).
 *
 * Direct / deep-link route. The canonical discovery surface is the
 * unified /dashboard/approvals?tab=timesheet page (reachable from the
 * Time & Leave strip's "Approvals" entry); this route is preserved as
 * a stable URL for managers who bookmarked it. Server-side the inbox
 * endpoint is role-scoped — a non-approver sees nothing useful.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/timesheet/inbox/page.tsx.
 * "use client" dropped; body is the existing ApprovalsTab component
 * (ported in Phase 3a) under the shared TimeAndLeaveShell.
 */

import { createFileRoute } from "@tanstack/react-router";
import { TimeAndLeaveShell } from "@/components/shared/time-and-leave-shell";
import { TimesheetFeatureGate } from "@/components/timesheet/timesheet-feature-gate";
import { ApprovalsTab } from "@/components/timesheet/approvals-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/timesheet/inbox",
)({
  component: TimesheetInboxRoute,
});

function TimesheetInboxRoute() {
  return (
    <TimeAndLeaveShell
      title="Timesheet approvals"
      description="Submitted weeks awaiting your review."
    >
      <TimesheetFeatureGate>
        <ApprovalsTab />
      </TimesheetFeatureGate>
    </TimeAndLeaveShell>
  );
}
